import './style.css';

const Loading = () => {
  return (
    <>
      <div>
        <div className="box-load">
          <div className="head1"></div>
          <div className="head2"></div>
          <div className="eats">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Loading;